import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const Rapporter = lazy(() => import("@/pages/mina-sidor/Rapporter"));

export const Route = createFileRoute("/mina-sidor/rapporter")({
  component: () => <Rapporter />,
});
